import styled from "styled-components";
import { ButtonSettings } from "../../../services/visualLibraryService";

// export const ButtonStyled = styled(ButtonSettings)`
//   ${props =>
//     props.displayBlock &&
//     `
//     display: block;
//     margin: auto;
//     margin-top: ${props.theme.spacing.medium};
//     width: 35rem;
//   `}
// `;
export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    ${props.isMarginTop &&
      `margin-top: ${props?.forVerticalSideModal ? props.theme.spacing.small : props?.customMarginTop ? props?.customMarginTop : props.theme.spacing.medium}`};
    width: ${props.isWidthIncrease ? "42rem" : props?.forVerticalSideModal ? "32rem" : "35rem"};
  `}
  &&& {
    ${props => props.lang === "fr" && `letter-spacing: 0.1px`};
    ${props => props.noborder && `border: 0`};
  }
  ${props => props.isLangBtn && `text-align:left;`}
  ${props => props.customWidth && `width:${props.customWidth};`}
  ${props => props.isModalCloseBtn && `width: 15rem;
    height: 2.8rem;
    font-size: 1.2rem;
    line-height: 1;
    position: absolute;
    bottom: 2rem;
    left: calc(50% - 7.5rem);
    `}
  ${props => props.customCSS && props.customCSS}
`;
